export const postApiSetting = (data) => {
    
    const settings = {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept:'application/json',
            'Content-Type':'application/json',
            // 'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
            
        },
        
        body: JSON.stringify(data)
    };
    return settings;
}
export const getApiSetting =()=>{

    return{
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + sessionStorage.getItem('token')
  }}
};


export const multiFocus = (target) => {
    let elems = document.querySelectorAll(target);
    let i = 0;
    let interval = setInterval(() => { 
        intervalCondition(); 
        i++; 
    }, 2);
    function intervalCondition(){
        if(i < elems.length) elems[i].focus();
        else clearInterval(interval)
    }
}

export const shortDate = (val) => {

    // console.log("val---",val)
    
   // let date = new Date(val).toLocaleDateString().split("/");  //before
    // let d = date[1]<10 ? `0${date[1]}`:date[1];
    // let m = date[0]<10 ? `0${date[0]}`:date[0];
    // let y = date[2];
    // let newDate = `${d}/${m}/${y}`; 
  //  let newDate = `${date[0]}/${date[1]}/${date[2]}`;  //before

    let dateStr=""
    const newval = val.replace("-","/")
    const newval1 = newval.replace("-","/")
    // console.log("newval---",newval)
    // console.log("newval1---",newval1)
    const olddateStr = newval1.split("/")
    // console.log("olddateStr--",olddateStr)
    
    dateStr+=olddateStr[1]
    dateStr=dateStr+"/"+olddateStr[2]
    dateStr=dateStr+"/"+olddateStr[0]

    // console.log("dateStr---",dateStr)
    return dateStr;
}

export const convertToISO = (dateStr) => {
    let [date, time] = dateStr.split(' ');
    let [day, month, year] = date.split('/');
    return `${year}-${month}-${day}T${time}`;
}

export const dateInNumbers = () => {
    let date = new Date().toLocaleString('it-IT').replace(/\/|,|:|\s/g,"");
    return date;
}

export const typeNumber = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
}

export const typeFloatNumber = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
}

export const stopTags = (e) => {
    e.target.value = e.target.value.replace(/<|>/g, '');
}